module.exports = "/assets/3j0eWqT_na.png";